import { BASE_API_URL } from "../../constants/constants";

export const requestGoogleForm = () => {
  const opts = `dependent=${1}, alwaysOnTop=${1}, alwaysRaised=${1}, alwaysRaised=${1}, width=${500}, height=${500}`;  
  return window.open(`${BASE_API_URL}/users/login.html`, 'bounceback_google_signin_window',opts);

}

